import { useEffect, useState } from 'react';
import { fetchThumbnail } from '../shared/api.ts';
import { kindOf } from '../shared/format.ts';

/**
 * Thumbnails sit behind the device token, so they cannot be a plain <img src>.
 * Files without one fall back to a two-letter type mark rather than an icon —
 * an icon per file type is decoration, the extension is information.
 */
export function Thumb({
  id,
  mime,
  hasThumbnail,
  name,
}: {
  id: string;
  mime: string;
  hasThumbnail: boolean;
  name: string;
}): React.JSX.Element {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!hasThumbnail) return;
    let revoked: string | null = null;
    let cancelled = false;

    void fetchThumbnail(id).then((objectUrl) => {
      if (cancelled) {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        return;
      }
      revoked = objectUrl;
      setUrl(objectUrl);
    });

    return () => {
      cancelled = true;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [id, hasThumbnail]);

  if (url) {
    return <img className="thumb" src={url} alt="" loading="lazy" decoding="async" />;
  }

  const dot = name.lastIndexOf('.');
  const label = dot > 0 && dot < name.length - 1 ? name.slice(dot + 1, dot + 5) : kindOf(mime).slice(0, 4);

  return (
    <span className="thumb thumb--empty mono" aria-hidden="true">
      {label.toLowerCase()}
    </span>
  );
}
